import { Box } from '@mui/material';
import AppDataGrid from '@shared/components/DataGrid';
import Loader from '@shared/components/Loader';
import { createShoppingListColumns } from '../features/stock/columns-shopping-list';
import { useFormatCurrency } from '@features/currency/currency.hooks';
import { useIntl } from 'react-intl';
import { createShoppingList } from '../features/stock/components/stock-shopping-list/entity';
import { mapStocksStockItemsToFlatStockItems } from '../features/stock/entity';
import { useStockItemsQuery } from '../features/stock/queries';

type ShoppingListProps = {
  columnHeaderHeight?: 0;
  hideFooter?: boolean;
};

const ShoppingList = (props: ShoppingListProps) => {
  const { columnHeaderHeight, hideFooter = false } = props;
  const { data: stocksStockItems } = useStockItemsQuery(undefined);
  const stockItems = mapStocksStockItemsToFlatStockItems(stocksStockItems);
  const intl = useIntl();
  const { format: formatAmount } = useFormatCurrency();

  if (!stockItems) {
    return <Loader />;
  }

  const shoppingList = createShoppingList(stockItems, intl);
  const shoppingListColumns = createShoppingListColumns(formatAmount);

  return (
    <Box sx={{ height: '100%' }}>
      <AppDataGrid
        rows={shoppingList}
        columns={shoppingListColumns}
        columnHeaderHeight={columnHeaderHeight}
        hideFooter={hideFooter}
      />
    </Box>
  );
};

export default ShoppingList;
